"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Records = void 0;
const environments = __importStar(require("../../../../environments"));
const core = __importStar(require("../../../../core"));
const Flatfile = __importStar(require("../../../index"));
const serializers = __importStar(require("../../../../serialization/index"));
const url_join_1 = __importDefault(require("url-join"));
const errors = __importStar(require("../../../../errors/index"));
class Records {
    constructor(_options = {}) {
        this._options = _options;
    }
    /**
     * Returns records from a sheet in a workbook
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.GetRecordsRequest} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     *
     * @example
     *     await client.records.get("us_sh_YOUR_ID")
     */
    get(sheetId, request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__get(sheetId, request, requestOptions));
    }
    __get(sheetId_1) {
        return __awaiter(this, arguments, void 0, function* (sheetId, request = {}, requestOptions) {
            var _a, _b, _c, _d, _e, _f;
            const { versionId, commitId, sinceVersionId, sinceCommitId, sortField, sortDirection, filter, filterField, searchValue, searchField, ids, pageSize, pageNumber, includeCounts, includeLength, includeLinks, includeMessages, fields, for: for_, q, } = request;
            const _queryParams = {};
            if (versionId != null) {
                _queryParams["versionId"] = versionId;
            }
            if (commitId != null) {
                _queryParams["commitId"] = commitId;
            }
            if (sinceVersionId != null) {
                _queryParams["sinceVersionId"] = sinceVersionId;
            }
            if (sinceCommitId != null) {
                _queryParams["sinceCommitId"] = sinceCommitId;
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = serializers.SortDirection.jsonOrThrow(sortDirection, {
                    unrecognizedObjectKeys: "strip",
                });
            }
            if (filter != null) {
                _queryParams["filter"] = serializers.Filter.jsonOrThrow(filter, { unrecognizedObjectKeys: "strip" });
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (ids != null) {
                if (Array.isArray(ids)) {
                    _queryParams["ids"] = ids.map((item) => serializers.RecordId.jsonOrThrow(item, { unrecognizedObjectKeys: "strip" }));
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            if (pageSize != null) {
                _queryParams["pageSize"] = pageSize.toString();
            }
            if (pageNumber != null) {
                _queryParams["pageNumber"] = pageNumber.toString();
            }
            if (includeCounts != null) {
                _queryParams["includeCounts"] = includeCounts.toString();
            }
            if (includeLength != null) {
                _queryParams["includeLength"] = includeLength.toString();
            }
            if (includeLinks != null) {
                _queryParams["includeLinks"] = includeLinks.toString();
            }
            if (includeMessages != null) {
                _queryParams["includeMessages"] = includeMessages.toString();
            }
            if (fields != null) {
                if (Array.isArray(fields)) {
                    _queryParams["fields"] = fields.map((item) => item);
                }
                else {
                    _queryParams["fields"] = fields;
                }
            }
            if (for_ != null) {
                _queryParams["for"] = for_;
            }
            if (q != null) {
                _queryParams["q"] = q;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/records`),
                method: "GET",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                queryParameters: _queryParams,
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.GetRecordsResponse.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    case 404:
                        throw new Flatfile.NotFoundError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                            rawResponse: _response.rawResponse,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling GET /sheets/{sheetId}/records.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    /**
     * Returns indices of records from a sheet in a workbook
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.GetRecordIndicesRequest} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     *
     * @example
     *     await client.records.indices("us_sh_YOUR_ID", {
     *         ids: "list<$commons.RecordId.Example0, $commons.RecordId.Example1>"
     *     })
     */
    indices(sheetId, request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__indices(sheetId, request, requestOptions));
    }
    __indices(sheetId, request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            const { commitId, sinceCommitId, sortField, sortDirection, filter, filterField, searchValue, searchField, ids, q, } = request;
            const _queryParams = {};
            if (commitId != null) {
                _queryParams["commitId"] = commitId;
            }
            if (sinceCommitId != null) {
                _queryParams["sinceCommitId"] = sinceCommitId;
            }
            if (sortField != null) {
                _queryParams["sortField"] = sortField;
            }
            if (sortDirection != null) {
                _queryParams["sortDirection"] = serializers.SortDirection.jsonOrThrow(sortDirection, {
                    unrecognizedObjectKeys: "strip",
                });
            }
            if (filter != null) {
                _queryParams["filter"] = serializers.Filter.jsonOrThrow(filter, { unrecognizedObjectKeys: "strip" });
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (Array.isArray(ids)) {
                _queryParams["ids"] = ids.map((item) => serializers.RecordId.jsonOrThrow(item, { unrecognizedObjectKeys: "strip" }));
            }
            else {
                _queryParams["ids"] = ids;
            }
            if (q != null) {
                _queryParams["q"] = q;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/records/indices`),
                method: "GET",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                queryParameters: _queryParams,
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.GetRecordIndicesResponse.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    case 404:
                        throw new Flatfile.NotFoundError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                            rawResponse: _response.rawResponse,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling GET /sheets/{sheetId}/records/indices.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    /**
     * Updates existing records in a workbook sheet
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.Records} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     *
     * @example
     *     await client.records.update("us_sh_YOUR_ID", [{
     *             id: "us_rc_YOUR_ID",
     *             versionId: "us_vr_YOUR_ID",
     *             commitId: "us_vr_YOUR_ID",
     *             values: {
     *                 "firstName": {
     *                     value: "John",
     *                     messages: [],
     *                     valid: true
     *                 },
     *                 "lastName": {
     *                     value: "Smith",
     *                     messages: [],
     *                     valid: true
     *                 },
     *                 "email": {
     *                     value: "john.smith@example.com",
     *                     messages: [],
     *                     valid: true
     *                 }
     *             },
     *             valid: true,
     *             metadata: {},
     *             config: {}
     *         }])
     */
    update(sheetId, request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__update(sheetId, request, requestOptions));
    }
    __update(sheetId, request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/records`),
                method: "PUT",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.Records.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.VersionResponse.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    case 404:
                        throw new Flatfile.NotFoundError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                            rawResponse: _response.rawResponse,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling PUT /sheets/{sheetId}/records.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    /**
     * Adds records to a workbook sheet
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.RecordData[]} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     *
     * @example
     *     await client.records.insert("us_sh_YOUR_ID", [{
     *             "firstName": {
     *                 value: "John",
     *                 messages: [],
     *                 valid: true
     *             },
     *             "lastName": {
     *                 value: "Smith",
     *                 messages: [],
     *                 valid: true
     *             },
     *             "email": {
     *                 value: "john.smith@example.com",
     *                 messages: [],
     *                 valid: true
     *             }
     *         }])
     */
    insert(sheetId, request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__insert(sheetId, request, requestOptions));
    }
    __insert(sheetId, request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/records`),
                method: "POST",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                requestType: "json",
                body: serializers.records.insert.Request.jsonOrThrow(request, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.RecordsResponse.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    case 404:
                        throw new Flatfile.NotFoundError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                            rawResponse: _response.rawResponse,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling POST /sheets/{sheetId}/records.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    /**
     * Deletes records from a workbook sheet
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.DeleteRecordsRequest} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     *
     * @example
     *     await client.records.delete("us_sh_YOUR_ID", {
     *         ids: "us_rc_YOUR_ID"
     *     })
     */
    delete(sheetId, request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__delete(sheetId, request, requestOptions));
    }
    __delete(sheetId, request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            const { ids } = request;
            const _queryParams = {};
            if (Array.isArray(ids)) {
                _queryParams["ids"] = ids.map((item) => serializers.RecordId.jsonOrThrow(item, { unrecognizedObjectKeys: "strip" }));
            }
            else {
                _queryParams["ids"] = ids;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/records`),
                method: "DELETE",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                queryParameters: _queryParams,
                requestType: "json",
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.Success.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                switch (_response.error.statusCode) {
                    case 400:
                        throw new Flatfile.BadRequestError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    case 404:
                        throw new Flatfile.NotFoundError(serializers.Errors.parseOrThrow(_response.error.body, {
                            unrecognizedObjectKeys: "passthrough",
                            allowUnrecognizedUnionMembers: true,
                            allowUnrecognizedEnumValues: true,
                            skipValidation: true,
                            breadcrumbsPrefix: ["response"],
                        }), _response.rawResponse);
                    default:
                        throw new errors.FlatfileError({
                            statusCode: _response.error.statusCode,
                            body: _response.error.body,
                            rawResponse: _response.rawResponse,
                        });
                }
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling DELETE /sheets/{sheetId}/records.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    /**
     * Searches for all values that match the 'find' value (globally or for a specific field via 'fieldKey') and replaces them with the 'replace' value. Wrap 'find' value in double quotes for exact match (""). Returns a commitId for the updated records
     *
     * @param {Flatfile.SheetId} sheetId - ID of sheet
     * @param {Flatfile.FindAndReplaceRecordRequest} request
     * @param {Records.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.records.findAndReplace("us_sh_YOUR_ID", {
     *         fieldKey: "email"
     *     })
     */
    findAndReplace(sheetId, request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__findAndReplace(sheetId, request, requestOptions));
    }
    __findAndReplace(sheetId, request, requestOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            const { filter, filterField, searchValue, searchField, ids, q } = request, _body = __rest(request, ["filter", "filterField", "searchValue", "searchField", "ids", "q"]);
            const _queryParams = {};
            if (filter != null) {
                _queryParams["filter"] = serializers.Filter.jsonOrThrow(filter, { unrecognizedObjectKeys: "strip" });
            }
            if (filterField != null) {
                _queryParams["filterField"] = filterField;
            }
            if (searchValue != null) {
                _queryParams["searchValue"] = searchValue;
            }
            if (searchField != null) {
                _queryParams["searchField"] = searchField;
            }
            if (ids != null) {
                if (Array.isArray(ids)) {
                    _queryParams["ids"] = ids.map((item) => serializers.RecordId.jsonOrThrow(item, { unrecognizedObjectKeys: "strip" }));
                }
                else {
                    _queryParams["ids"] = ids;
                }
            }
            if (q != null) {
                _queryParams["q"] = q;
            }
            const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
                url: (0, url_join_1.default)((_c = (_b = (yield core.Supplier.get(this._options.baseUrl))) !== null && _b !== void 0 ? _b : (yield core.Supplier.get(this._options.environment))) !== null && _c !== void 0 ? _c : environments.FlatfileEnvironment.Production, `/sheets/${encodeURIComponent(serializers.SheetId.jsonOrThrow(sheetId))}/find-replace`),
                method: "PUT",
                headers: Object.assign({ Authorization: yield this._getAuthorizationHeader(), "X-Disable-Hooks": (_f = (_d = requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.xDisableHooks) !== null && _d !== void 0 ? _d : (_e = this._options) === null || _e === void 0 ? void 0 : _e.xDisableHooks) !== null && _f !== void 0 ? _f : "true", "X-Fern-Language": "JavaScript", "X-Fern-SDK-Name": "@flatfile/api", "X-Fern-SDK-Version": "1.17.3", "User-Agent": "@flatfile/api/1.17.3", "X-Fern-Runtime": core.RUNTIME.type, "X-Fern-Runtime-Version": core.RUNTIME.version }, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.headers),
                contentType: "application/json",
                queryParameters: _queryParams,
                requestType: "json",
                body: serializers.FindAndReplaceRecordRequest.jsonOrThrow(_body, { unrecognizedObjectKeys: "strip" }),
                timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000,
                maxRetries: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.maxRetries,
                abortSignal: requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.abortSignal,
            });
            if (_response.ok) {
                return {
                    data: serializers.VersionResponse.parseOrThrow(_response.body, {
                        unrecognizedObjectKeys: "passthrough",
                        allowUnrecognizedUnionMembers: true,
                        allowUnrecognizedEnumValues: true,
                        skipValidation: true,
                        breadcrumbsPrefix: ["response"],
                    }),
                    rawResponse: _response.rawResponse,
                };
            }
            if (_response.error.reason === "status-code") {
                throw new errors.FlatfileError({
                    statusCode: _response.error.statusCode,
                    body: _response.error.body,
                    rawResponse: _response.rawResponse,
                });
            }
            switch (_response.error.reason) {
                case "non-json":
                    throw new errors.FlatfileError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.rawBody,
                        rawResponse: _response.rawResponse,
                    });
                case "timeout":
                    throw new errors.FlatfileTimeoutError("Timeout exceeded when calling PUT /sheets/{sheetId}/find-replace.");
                case "unknown":
                    throw new errors.FlatfileError({
                        message: _response.error.errorMessage,
                        rawResponse: _response.rawResponse,
                    });
            }
        });
    }
    _getAuthorizationHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const bearer = yield core.Supplier.get(this._options.token);
            if (bearer != null) {
                return `Bearer ${bearer}`;
            }
            return undefined;
        });
    }
}
exports.Records = Records;
